// 9 Oct: one line across the top of the phone while it has no connection, gone the moment it is back. Rendered once per
// page, in flow at the top of the frame (the game page and the join page), above the header band, so the band and the
// controls stay where they are and move down together; nothing fixed, no portal, so a screen leaving through a
// transition never carries a second copy. The orange notice style every look already has; an alert, so it is read out.
import { useOnline } from '@/lib/online';

export const OFFLINE = { line: "No connection. We'll keep trying." } as const;

export function OfflineBanner() {
  const online = useOnline();
  if (online) return null;
  return (
    <div data-part="offline-banner" className="mx-auto w-full max-w-md px-4 pt-[max(0.5rem,env(safe-area-inset-top))]">
      <p role="alert" className="rounded-tile border border-cart bg-cart-soft px-4 py-2 text-center text-sm font-semibold leading-snug text-ink">{OFFLINE.line}</p>
    </div>
  );
}
